var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyesdark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.491 12.362.933-.359-.933.36Zm0 1.187-.933-.36.933.36Zm-18.67-1.187-.933-.359.933.36Zm0 1.187-.933.36.933-.36Zm.933-.827a9.004 9.004 0 0 1 8.402-5.766v-2c-4.683 0-8.68 2.926-10.268 7.047l1.866.719Zm8.402-5.766a9.004 9.004 0 0 1 8.402 5.766l1.866-.719c-1.587-4.12-5.584-7.047-10.268-7.047v2Zm8.402 6.233a9.004 9.004 0 0 1-8.402 5.767v2c4.684 0 8.681-2.927 10.268-7.048l-1.866-.719Zm-8.402 5.767a9.004 9.004 0 0 1-8.402-5.767l-1.866.72c1.587 4.12 5.585 7.047 10.268 7.047v-2Zm8.402-6.234a.65.65 0 0 1 0 .467l1.866.72a2.65 2.65 0 0 0 0-1.906l-1.866.719Zm-18.67-.719a2.65 2.65 0 0 0 0 1.905l1.866-.719a.651.651 0 0 1 0-.467l-1.866-.719Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 12.156,
    cy: 12.956,
    r: 3,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesdark);
export default __webpack_public_path__ + "static/media/eyesdark.0ec9841975452e870f5c82bc37528863.svg";
export { ForwardRef as ReactComponent };